import { Link, useNavigate } from '@remix-run/react';
import clsx from 'clsx';

interface ColourFilterProps {
	hex: string;
	secondaryHex?: string | null;
	name: string;
	url: string;
	active?: boolean;
	isSamedayIds?: string[];
	hideOnMobile?: boolean;
	max?: number;
	selectedColour?: string;
	onClick?: (id: string) => void;
	className?: string;
}

export function ColourFilter({ name, hex, url, secondaryHex, active }: ColourFilterProps) {
	return (
		<Link prefetch="intent" key={hex} title={name} type="button" to={url} className="group flex items-center space-x-2 py-1">
			<div
				className={clsx(
					'relative border border-grey rounded-full focus:ring-1 focus:ring-blue focus:outline-none transition-all duration-75 ease-in-out',
					active ? 'ring-1 ring-blue pointer-events-none' : 'ring-0 group-hover:ring-1 group-hover:ring-blue',
				)}
			>
				<div
					className="w-5 h-5 lg:w-6 lg:h-6 rounded-full"
					style={{
						background:
							secondaryHex && secondaryHex !== hex
								? `linear-gradient( -45deg, ${hex} 49%, white 49%, white 51%, ${secondaryHex} 51% )`
								: hex,
					}}
				/>
			</div>
			<p>{name}</p>
		</Link>
	);
}
